/*
 * @Description:
 * @Author: gonghong
 * @Date: 2024-02-19 10:31:23
 * @LastEditTime: 2024-02-23 15:33:29
 */
import '@/assets/style/index.less'
import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import { store } from '@/store'
import { useComponents } from '@/plugins/components'
import { setupGlobalProperties } from '@/plugins/globalProperties'
const initApp = async() => {
    const app = createApp(App)
    setupGlobalProperties(app)
    // 注册antd组件
    useComponents(app)
    app.use(store)
    app.use(router)
    await router.isReady()
    app.mount('#app', true)
}
initApp()
